/**
 * @file コンポーネント：フル動画ページ機器広告ポップアップ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import {
    fnHandleApiErrors,
    fnHandleApiSuccess,
    fnPushDataLayerGtm,
} from "~/src/functions/common";
import { fnSendEventHubspot } from "~/src/functions/hubspot";

// コンポーネントを返す
export const PopupAd = (props) => {
    /**
     * ポップアップの開閉
     */
    const [isOpen, setIsOpen] = useState(false);
    const [list, setList] = useState([]);
    const refContents = useRef(null);
    useEffect(() => {
        if (props.isOpenPopupAd === true) {
            if (list.length === 0) {
                // 機器広告資料画像未取得時
                const api =
                    "/api/adOperations/materials/" +
                    props.operationId +
                    "?language=" +
                    props.languageCodeOperation;
                fetch(api)
                    .then(fnHandleApiErrors)
                    .then(fnHandleApiSuccess)
                    .then((result) => {
                        if (result !== null) {
                            // スライドの画像データセット
                            setList(result);
                            // スライドのDOM監視設定
                            const observer = new MutationObserver(() => {
                                // スライドの画像が読み込み完了後
                                const images =
                                    refContents.current.querySelectorAll("img");
                                if (images !== undefined) {
                                    images.forEach((img) => {
                                        img.addEventListener(
                                            "load",
                                            () => {
                                                // ポップアップを開く
                                                setIsOpen(true);
                                                // 監視の停止
                                                observer.disconnect();
                                            },
                                            { once: true }
                                        );
                                    });
                                }
                            });
                            // スライドのDOM監視開始
                            observer.observe(refContents.current, {
                                childList: true,
                                subtree: true,
                            });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else {
                // 機器広告資料画像取得済み時
                setIsOpen(true);
            }
        }
    }, [props.isOpenPopupAd]);

    /**
     * isOpenとprops.isOpenPopupAdの同期
     */
    useEffect(() => {
        props.setIsOpenPopupAd(isOpen);
    }, [isOpen]);

    /**
     * 機器広告お問い合わせボタンクリック処理
     */
    const fnOnClickContact = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // 機器広告ポップアップを閉じる
        setIsOpen(false);
        // 機器広告問い合わせ確認モーダルを開く
        props.setIsOpenModalAdConfirm(true);
        // HubSpotにイベントを送信
        fnSendEventHubspot({
            name: "pe21169348_ad_contact",
            properties: {
                ad_contact_click: null,
            },
        });
        // Google Tag Manager カスタムイベントトリガー
        fnPushDataLayerGtm({
            event: "AdOperationRequest",
            operationId: window.atob(props.operationId),
            userId: window.dataUser.userId,
        });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnClickContact={fnOnClickContact}
            isOpen={isOpen}
            list={list}
            refContents={refContents}
            setIsOpen={setIsOpen}
        />
    );
};
